import {
  serviceInfo,
  getServiceCountPrice,
  servicePay,
  getSmsLave
} from '@/services/config'
import i18n from '@/lib/language'
const store = {
  namespaced: true,
  state: {
    setSubmitting: false,
    crumbLabel: i18n.t('message["312"]'),
    serviceInfo: {}
  },
  mutations: {
    setSubmitting (state, type) {
      state.setSubmitting = type
    },
    setCrumbLabel (state, value) {
      state.crumbLabel = value
    },
    setServiceInfo (state, data) {
      state.serviceInfo = data
    }
  },
  actions: {
    async getServiceInfo ({ commit }) {
      commit('setSubmitting', true)
      const chain = await serviceInfo()
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    },
    // 计算服务价格
    async getCountPrice ({ commit }, data) {
      commit('setSubmitting', true)
      const chain = await getServiceCountPrice()
        .params(data)
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    },
    async pay ({ commit }) {
      commit('setSubmitting', true)
      const chain = await servicePay()
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: true })
      return chain
    },
    async setCrumbLabel ({ commit }, value) {
      commit('setCrumbLabel', value)
    },
    async setServiceInfoData ({ commit }, data) {
      commit('setServiceInfo', data)
      // if (data.vip) {
      //   commit('setCrumbLabel', i18n.t('message["579"]')) // i18n.t('message["579"]')
      //   if (data.remark.usedvip === 1) {
      //     commit('setCrumbLabel', i18n.t('message["312"]'))
      //   }
      // } else {
      //   commit('setCrumbLabel', i18n.t('message["312"]'))
      // }
    },
    // 获取短信、邮件余量信息
    async getLaveInfo ({ commit }, type) {
      commit('setSubmitting', true)
      const chain = await getSmsLave()
        .params(type)
        .onNetComplete(() => {
          commit('setSubmitting', false)
        })
        .config({ tip: false })
      return chain
    }
  }
}

export default store
